import React, { useEffect } from 'react';
import { isMobile } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';
import { numPadTypes } from '../../../../enums';

export const CashOutOdd = ({
  autoCashOutOdd,
  onChangeAutoCashOut,
  handleAutoCashOutOdd,
  handleOpenNumPad,
  isAutoBet,
  maxWinValue,
}) => {
  useEffect(() => {
    gameConfigStore.setMaxAutoCashOutOdd(maxWinValue);
  }, [maxWinValue]);

  return (
    <div className={`cashout-input-box  ${isAutoBet ? 'disabled' : ''}`}>
      <div
        className={`cashout-input-box-icon   left `}
        onClick={() => handleAutoCashOutOdd(AdditionalInputValueChangingButtons.minus)}
      >
        <i className='ui-lib-minus' />
      </div>
      <input
        type='text'
        className='cashout-inp-block'
        maxLength='9'
        inputMode='none'
        value={autoCashOutOdd}
        readOnly={isMobile()}
        onChange={onChangeAutoCashOut}
        onPaste={(e) => {
          e.preventDefault();
        }}
        onBlur={() => {
          handleAutoCashOutOdd(AdditionalInputValueChangingButtons.inputBlur);
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
        {...(isMobile()
          ? {
              onClick: (e) => handleOpenNumPad(e, numPadTypes.autoCashOutOdd),
            }
          : {})}
      />
      <div
        className='cashout-input-box-icon right'
        onClick={() => handleAutoCashOutOdd(AdditionalInputValueChangingButtons.plus)}
      >
        <i className='ui-lib-plus' />
      </div>
    </div>
  );
};
